import Layout from '@/views/layout'
/**
 * 商户中心
 */
const myAccount = () => import('@/views/account/myAccount')
const serviceSet = () => import('@/views/merchantCenter/serviceSet')
const messageManage = () => import('@/views/messageManage/messageManage')
const messageNotice = () => import('@/views/messageManage/messageNotice')
const voiceService = () => import('@/views/merchantCenter/voiceService')

export default [
  {
    path: '/merchant',
    name: 'merchant',
    redirect: '/merchant/accountManage',
    component: Layout,
    meta: {
      title: '商户中心',
      icon: 'merchant.png',
      index: 15
    },
    children: [
      {
        path: 'accountManage',
        name: 'accountManage',
        meta: {
          title: '账号管理',
          id: '1631502671',
          trackName: '商户中心-账号管理'
        },
        component: () => import('@/views/gasStationManage/accountManage')
      },
      {
        path: 'myAccount',
        name: 'myAccount',
        component: myAccount,
        meta: { title: '我的账号'},
      },
      {
        path: 'serviceSet',
        name: 'serviceSet',
        component: serviceSet,
        meta: { title: '服务配置' }
      },
      {
        path: 'voiceService',
        name: 'voiceService',
        component: voiceService,
        meta: { title: '播报服务' }
      },
      {
        path: 'messageManage',
        name: 'messageManage',
        component: messageManage,
        meta: { title: '消息管理' }
      },
      {
        path: 'messageNotice',
        name: 'messageNotice',
        component: messageNotice,
        hidden: true,
        meta: { title: '消息查看' }
      }
    ]
  }
]